import { render, staticRenderFns } from "./export-trends-1pmc.vue?vue&type=template&id=5f1c742a&"
import script from "./export-trends-1pmc.vue?vue&type=script&lang=js&"
export * from "./export-trends-1pmc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1c742a')) {
      api.createRecord('5f1c742a', component.options)
    } else {
      api.reload('5f1c742a', component.options)
    }
    module.hot.accept("./export-trends-1pmc.vue?vue&type=template&id=5f1c742a&", function () {
      api.rerender('5f1c742a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/1pmc/export-trends-1pmc.vue"
export default component.exports